
import gustibusConfigData from '../config-data.js';

document.addEventListener('DOMContentLoaded', () => {


const productCategories = document.querySelectorAll('.product-categories .product-category');
const productSubcategoriesSection = document.querySelector('.product-subcategories');
const productSubcategories = document.querySelectorAll('.product-subcategories .product-subcategory');
const productGroupsSection = document.getElementById('product-groups');
const firstStepNextBtnSection = document.querySelector('.first-step-wrapper .next-wrapper');

const productCategoriesContainer = document.getElementById('product-categories');

function createCategoryElement(category, index) {
    const categoryElement = document.createElement('div');
    categoryElement.classList.add('product-category');
    categoryElement.setAttribute('data-index', index);
    categoryElement.setAttribute('data-id', category.id);
    categoryElement.style.order = category.order;

    const pictureElement = document.createElement('picture');

    const sourceElement = document.createElement('source');
    sourceElement.setAttribute('srcset', category.image);
    sourceElement.setAttribute('data-srcset', category.image);
    sourceElement.setAttribute('type', 'image/webp');

    const imgElement = document.createElement('img');
    imgElement.setAttribute('src', category.image);
    imgElement.setAttribute('data-src', category.image);
    imgElement.setAttribute('alt', '');
    imgElement.classList.add('product-step');

    pictureElement.appendChild(sourceElement);
    pictureElement.appendChild(imgElement);

    const categoryNameElement = document.createElement('p');
    categoryNameElement.classList.add('product-category-name');
    categoryNameElement.textContent = category.name;

    categoryElement.appendChild(pictureElement);
    categoryElement.appendChild(categoryNameElement);

    categoryElement.addEventListener('click', () => {
        firstStepNextBtnSection.classList.remove('active');

        const selectedSubcategoryElement = document.querySelector('.product-subcategories .product-subcategory.active');
        if(selectedSubcategoryElement) {
            selectedSubcategoryElement.classList.remove('active');
        }
        const selectedGroupElement = document.querySelector('.product-groups .product.active');
        if(selectedGroupElement) {
            selectedGroupElement.classList.remove('active');
        }

        const allCategories = document.querySelectorAll('.product-category');
        allCategories.forEach(p => {
            p.classList.remove('active');
        });
        categoryElement.classList.add('active');
        const categoryIndex = parseInt(categoryElement.dataset.index);
        const subcategories = gustibusConfigData.categories[category.id].subcategories;
        displaySubcategories(subcategories);

        productGroupsSection.classList.remove('active');
        productSubcategoriesSection.classList.add('active');
    });

    return categoryElement;
}

function displaySubcategories(subcategories) {
    const productSubcategoriesContainer = document.getElementById('product-subcategories');
    productSubcategoriesContainer.innerHTML = '';
    if(!subcategories) {
        firstStepNextBtnSection.classList.add('active');
        return;
    }

    const subIDS = Object.keys(subcategories);
    subIDS.forEach((id, index) => {
        const subcategory = subcategories[id];
        const subcategoryElement = document.createElement('div');
        subcategoryElement.classList.add('product-subcategory');
        subcategoryElement.setAttribute('data-id', id);
        subcategoryElement.style.order = subcategory.order;

        const subcategoryNameElement = document.createElement('p');
        subcategoryNameElement.classList.add('product-subcategory-name');
        subcategoryNameElement.textContent = subcategory.name;

        subcategoryElement.appendChild(subcategoryNameElement);
        productSubcategoriesContainer.appendChild(subcategoryElement);

        subcategoryElement.addEventListener('click', () => {
            firstStepNextBtnSection.classList.remove('active');

            const allSubcategories = document.querySelectorAll('.product-subcategory');
            const isActive = subcategoryElement.classList.contains('active');

            const selectedGroupElement = document.querySelector('.product-groups .product.active');
            if(selectedGroupElement) {
                selectedGroupElement.classList.remove('active');
            }

            allSubcategories.forEach(sub => {
                sub.classList.remove('active');
            });

            if (!isActive) {
                subcategoryElement.classList.add('active');

                if(subcategory.groups) {
                    displayGroups(subcategory.groups);
                } else {
                    removeGroups();
                    firstStepNextBtnSection.classList.add('active');
                    return;
                }
            } else {
                productGroupsSection.classList.remove('active');
            }
        });
    });
}

function removeGroups() {
    const productGroupsContainer = document.getElementById('product-groups');
    productGroupsContainer.innerHTML = '';

}

function displayGroups(groups) {
    const productGroupsContainer = document.getElementById('product-groups');
    productGroupsContainer.innerHTML = '';

    const groupIDs = Object.keys(groups);
    groupIDs.forEach((id, index) => {
        const group = groups[id];
        const groupElement = document.createElement('div');
        groupElement.classList.add('product');
        groupElement.setAttribute('data-id', id);
        groupElement.style.order = group.order;

        const pictureElement = document.createElement('picture');

        const sourceElement = document.createElement('source');
        sourceElement.setAttribute('media', '(min-width: 768px)');
        sourceElement.setAttribute('srcset', group.image);
        sourceElement.setAttribute('data-srcset', group.image);
        sourceElement.setAttribute('type', 'image/webp');

        const imgElement = document.createElement('img');
        imgElement.setAttribute('src', group.image);
        imgElement.setAttribute('data-src', group.image);
        imgElement.setAttribute('alt', '');
        imgElement.classList.add('group-img');

        pictureElement.appendChild(sourceElement);
        pictureElement.appendChild(imgElement);

        const groupNameElement = document.createElement('p');
        groupNameElement.classList.add('product-group-name');
        groupNameElement.textContent = group.name;

        groupElement.appendChild(pictureElement);
        groupElement.appendChild(groupNameElement);

        productGroupsContainer.appendChild(groupElement);

        groupElement.addEventListener('click', () => {
            const allGroups = document.querySelectorAll('.product-groups .product');
            const isActive = groupElement.classList.contains('active');

            allGroups.forEach(group => {
                group.classList.remove('active');
            });

            if (!isActive) {
                groupElement.classList.add('active');
                firstStepNextBtnSection.classList.add('active');
            } else {
                firstStepNextBtnSection.classList.remove('active');
            }
        });
    });

    productGroupsSection.classList.add('active');
}

const categoriesIDS = Object.keys(gustibusConfigData.categories);

categoriesIDS.forEach((id, index) => {
    const category = gustibusConfigData.categories[id];
    const categoryElement = createCategoryElement(category, index);
    productCategoriesContainer.appendChild(categoryElement);
});
// gustibusConfigData.categories.forEach((category, index) => {
//     const categoryElement = createCategoryElement(category, index);
//     productCategoriesContainer.appendChild(categoryElement);
// });

window.mergedData = {
    selectedCategory: null,
    selectedSubcategory: null,
    selectedGroup: null,
    selectedFormat: null,
    selectedBrand: null,
    selectedQuantity: null
};

function savestepOneData() {
    window.mergedData = {
        selectedCategory: null,
        selectedSubcategory: null,
        selectedGroup: null,
        selectedFormat: null,
        selectedBrand: null,
        selectedQuantity: null
    };

    const selectedCategoryElement = document.querySelector('.product-categories .product-category.active');
    if (selectedCategoryElement) {
        window.mergedData.selectedCategory = selectedCategoryElement.getAttribute('data-id');
    }

    const selectedSubcategoryElement = document.querySelector('.product-subcategories .product-subcategory.active');
    if (selectedSubcategoryElement) {
        window.mergedData.selectedSubcategory = selectedSubcategoryElement.getAttribute('data-id');
    }

    const selectedGroupElement = document.querySelector('.product-groups .product.active');
    if (selectedGroupElement) {
        window.mergedData.selectedGroup = selectedGroupElement.getAttribute('data-id');
    }

    return window.mergedData;
}

firstStepNextBtnSection.addEventListener('click', () => {
    savestepOneData();
});

});
